import { LatestNewsSection } from './LatestNewsSection';
import { TrendyNowSection } from './TrendyNowSection';

export const NewsSections = () => (
    <>
        <LatestNewsSection />
        <TrendyNowSection />
    </>
);
